module.exports = __webpack_public_path__ + "DSC05476.2d36e47bd7b1f649b147.jpg";